<script>
import { Bar } from "vue-chartjs";
import mushroom from "viettoc-api";
import MethodService from "../../../service/MethodService";
export default {
  props: ["select"],
  extends: Bar,
  data() {
    return {
      labels: [],
      data: [],
    };
  },
  methods: {
    async fn_initData() {
      try {
        for (let i = 1; i < 13; i++) {
          const response =
            await mushroom.ldp_bai_viet.views.get_so_luong_bai_vietAsync({
              year: new Date().getFullYear(),
              month: i,
            });

          this.data.push(
            response.result.length > 0 ? response.result[0].total : 0
          );
        }
        this.$emit("loadDone");
      } catch (e) {
        MethodService.showError(e.code);
        console.log(e);
      }
    },
    fn_renderMonth() {
      for (let i = 1; i < 13; i++) {
        this.labels.push("Tháng " + i);
      }
    },
  },

  async mounted() {
    await this.fn_initData();
    this.fn_renderMonth();
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: "Số bài viết",
            backgroundColor: "rgba(255,99,132,0.2)",
            borderColor: "rgba(255,99,132,1)",
            borderWidth: 1,
            hoverBackgroundColor: "rgba(255,99,132,0.4)",
            hoverBorderColor: "rgba(255,99,132,1)",
            data: this.data,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true, // minimum value will be 0.
              },
            },
          ],
        },
      }
    );
  },
};
</script>
